import React from 'react';
import './ProductsPage.css';
import { useNavigate } from 'react-router-dom';
import { RadioTower, AudioWaveform, Speaker, Repeat, ToggleLeft, Users } from 'lucide-react';

const ProductsPage = () => {
  const navigate = useNavigate();

  const productCategories = [
    {
      id: 1,
      title: 'مرسلات FM',
      description: 'مرسلات FM و LPFM للبث مع مشغلات DDS ومليئة بالميزات لجميع محطات الراديو.',
      icon: <RadioTower size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/products/fm-transmitters'
    },
    {
      id: 2,
      title: 'معالجات الصوت',
      description: 'معالجات صوت FM بأحدث التقنيات المصممة للاستخدام في محطتك الإذاعية',
      icon: <AudioWaveform size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/products/audio-processors'
    },
    {
      id: 3,
      title: 'مضخمات FM',
      description: 'مضخمات بث FM مع مدخلات RF مزدوجة ومليئة بالميزات لجميع محطات الراديو.',
      icon: <Speaker size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/products/fm-amplifiers'
    },
    {
      id: 4,
      title: 'مترجمات FM',
      description: 'مترجمات بث FM مع موالف مدمج ومليئة بالميزات لجميع محطات الراديو.',
      icon: <Repeat size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/products/fm-translators'
    },
    {
      id: 5,
      title: 'مفاتيح التبديل',
      description: 'وحدات تبديل 1+1 مكتملة الميزات مصممة للعمل مع معظم علامات مرسلات FM.',
      icon: <ToggleLeft size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/products/changeover-switches'
    },
    {
      id: 6,
      title: 'منتجات الشراكة',
      description: 'منتجات ننتجها بالتعاون مع الشركاء - Aqua Broadcast & Partners',
      icon: <Users size={64} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/products/aqua-broadcast-partners'
    }
  ];

  const featuredProducts = [
    {
      id: 1,
      title: 'مرسلات COBALT FM',
      subtitle: '10W حتى 5KW مرسل FM مكتمل الميزات',
      description: 'جميع مرسلات COBALT تتمتع بجودة صوت فائقة ووضوح صوتي بفضل تقنية Digital to Channel المباشرة.',
      buttonText: 'اقرأ المزيد',
      link: 'https://aquabroadcast.co.uk/products/cobalt-fm-transmitters'
    },
    {
      id: 2,
      title: 'عرض COBALT التوضيحي',
      subtitle: 'ألق نظرة فاحصة على الميزات المتاحة',
      description: 'جرب واجهة COBALT التفاعلية واستكشف جميع الميزات المتقدمة المتاحة في مرسلاتنا.',
      buttonText: 'اقرأ المزيد',
      link: 'https://aquabroadcast.co.uk/products/cobalt-demo'
    },
    {
      id: 3,
      title: 'مضخمات FM',
      subtitle: 'مضخمات COBALT FM المتميزة',
      description: 'تتميز مضخمات COBALT FM بتقنية Dual-Drive الفريدة مع مدخلات طاقة منخفضة، مما يوفر لك تكرار إضافي.',
      buttonText: 'اقرأ المزيد',
      link: 'https://aquabroadcast.co.uk/products/fm-amplifiers'
    },
    {
      id: 4,
      title: 'معالج الصوت FM',
      subtitle: 'Arctic - 4 نطاقات',
      description: 'هل أنت شغوف بالمعالجة؟ مجموعتنا المتميزة ستجعل محطتك تتميز عن المنافسة.',
      buttonText: 'اقرأ المزيد',
      link: 'https://aquabroadcast.co.uk/products/audio-processors'
    }
  ];

  const handleCategoryClick = (link) => {
    window.open(link, '_blank');
  };

  const handleProductClick = (link) => {
    window.open(link, '_blank');
  };

  return (
    <div className="products-page">
      <div className="container">
        {/* Page Header */}
        <div className="page-header">
          <h1 className="page-title">منتجاتنا</h1>
          <p className="page-subtitle">
            اكتشف مجموعتنا الكاملة من معدات البث الإذاعي عالية الجودة والمصممة للمهندسين من قبل المهندسين
          </p>
        </div>

        {/* Product Categories Grid */}
        <section className="categories-section">
          <h2 className="section-title">فئات المنتجات</h2>
          <div className="categories-grid">
            {productCategories.map((category) => (
              <div 
                key={category.id} 
                className="category-card"
                onClick={() => handleCategoryClick(category.link)}
              >
                <div className="category-icon">
                  {category.icon}
                </div>
                <h3 className="category-title">{category.title}</h3>
                <p className="category-description">{category.description}</p>
                <div className="category-arrow">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="cta-section">
          <div className="cta-content">
            <h2 className="cta-title">هل تحتاج مساعدة في اختيار المنتج المناسب؟</h2>
            <p className="cta-description">
              فريقنا من الخبراء جاهز لمساعدتك في العثور على الحل الأمثل لاحتياجات محطتك الإذاعية
            </p>
            <div className="cta-buttons">
              <button 
                className="cta-button primary"
                onClick={() => navigate('/contact')}
              >
                اتصل بنا
              </button>
              <button 
                className="cta-button secondary"
                onClick={() => {
                  navigate('/');
                  setTimeout(() => {
                    const supportSection = document.getElementById('support');
                    if (supportSection) {
                      supportSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }, 100);
                }}
              >
                احصل على الدعم
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProductsPage;
